import {
    Badge, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger,
    VStack,
} from '@chakra-ui/react';
import React, { ComponentProps } from 'react';

function PopoverTag({
    popoverPlacement = 'auto',
    children,
    colorScheme,
    title,
}: {
    children?: React.ReactNode;
    popoverPlacement: ComponentProps<typeof Popover>['placement'];
    colorScheme: ComponentProps<typeof Badge>['colorScheme'];
    title: string;
}) {
    if (React.Children.count(children) === 0) {
        return <Badge colorScheme={colorScheme} userSelect="none">{title}</Badge>;
    }

    return (
        <Popover isLazy lazyBehavior="keepMounted" trigger="hover" placement={popoverPlacement}>
            <PopoverTrigger>
                <Badge colorScheme={colorScheme} cursor="pointer" userSelect="none">{title}</Badge>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverBody>
                    <VStack alignItems="flex-start" gap={0}>
                        {children}
                    </VStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

export { PopoverTag };
